export default "__VITE_PUBLIC_ASSET__3a61f62e__"